// extracted by mini-css-extract-plugin
module.exports = {"root":"ArrowButton_root__2Yk0G","icon":"ArrowButton_icon__wIZUM","next":"ArrowButton_next__NlnU_"};